export default __webpack_public_path__ + "static/media/gallery - original vs translated_01.784d5385.jpg";